import React from 'react'
import './audio-intro.css'

export const SpinnerComponent = ({ mobile }) => (
  <div style={ mobile ? { transform: 'scale(.6)' } : {} }  id='loading'>
    <div className='outer-shadow'></div>
    <div className='inner-shadow'></div>
    <div className='timer'>
      <div className='dot'>
        <span></span>
      </div>
      <div className='hold' id='left'>
        <div className='pie'></div>
      </div>
      <div className='hold' id='right'>
        <div className='pie'></div>
      </div>
    </div>
  </div>
);
